import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = () => ({
  projects: {
    results: [],
  },
  projectExperts: {
    results: [],
  },
  loading: false,
  matrixReportData: {
    avg_graph: {
      dependent: '0',
      influential: '0',
    },
    data: [],
    graph_data: [],
    count: 0,
  },
})

export const getters = {
  projects: (state) => state.projects,
  loadingProjects: (state) => state.loading,
  projectExperts: (state) => state.projectExperts,
  matrixReportData: (state) => state.matrixReportData,
}

export const mutations = {
  SET_METHODOLOGIST_PROJECTS(state, projects) {
    state.projects = projects
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_PROJECTS_EXPERTS(state, projects) {
    state.projectExperts = projects
  },
  SET_MATRIX_REPORT_DATA(state, data) {
    state.matrixReportData = { ...data }
  },
}

export const actions = {
  fetchProjects({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      axios
        .get(
          appConfig.server_url +
            '/profile_management/profile/?user_id=expert&role=0'
        )
        .then((resp) => {
          commit('SET_METHODOLOGIST_PROJECTS', resp.data)
          commit('SET_LOADING', false)
          resolve(resp)
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          store.dispatch('utils/message', {
            type: 'error',
            title: 'Error',
            text: 'Error consultando proyectos',
          })
          reject(error)
        })
    })
  },
  fetchProjectExperts({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios
      .get(
        appConfig.server_url +
          `/profile_management/profile/?project=${projectId}&role=1`
      )
      .then((resp) => {
        commit('SET_PROJECTS_EXPERTS', resp.data)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando expertos',
        })
      })
  },
  createExpert({ commit, dispatch }, payload) {
    if (payload.user.password === null) {
      delete payload.user.password
    }
    commit('SET_LOADING', true)
    axios
      .post(appConfig.server_url + '/profile_management/profile/', payload)
      .then((resp) => {
        dispatch('fetchProjectExperts', payload.project_id)
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Experto creado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error creando experto',
        })
      })
  },
  createPublicExpert({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    return axios
      .post(
        `${appConfig.server_url}/profile_management/profile/public_register/`,
        payload
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err.response
      })
  },
  updateExpert({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    axios
      .put(payload.url, payload)
      .then((resp) => {
        commit('SET_LOADING', false)
        dispatch('fetchProjectExperts', payload.project_id)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Experto actializado correctamente.',
        })
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error actualizando experto',
        })
      })
  },
  deleteExpert({ dispatch }, payload) {
    axios
      .delete(payload.url)
      .then((resp) => {
        dispatch('fetchProjectExperts', payload.projectId)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Experto eliminado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error eliminando experto',
        })
      })
  },
  fetchProjectMatrixData({ commit }, payload) {
    const { projectId } = payload
    axios
      .get(
        appConfig.server_url +
          `/projects_management/reports/auditchangefactormatrix?project_id=${projectId}&graph_data=true`
      )
      .then((resp) => {
        if (resp.status === 200) {
          commit('SET_MATRIX_REPORT_DATA', resp.data)
        }
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando datos de matriz',
        })
      })
  },
}
